import React from 'react';
import {zoomService} from '../../../service/zoom.service';
import Button from '../../../incase-domain/components/button/Button';

function ZoomLoginButton(): JSX.Element {
    const handleLogin = (): void => {
        zoomService.login();
    };

    return (
        <Button variant="soft" color="primary" leading="pajamas:brand-zoom" size="md" onClick={handleLogin} dataCy="zoom_login_button">
            Continue with Zoom
        </Button>
    );
}

export default ZoomLoginButton;
